export default __webpack_public_path__ + "static/media/01.ef3ce321.jpg";